import { MinusIcon } from '@chakra-ui/icons';
import { HStack, IconButton, Text } from '@chakra-ui/react';
import { FC } from 'react';

type Props = {
  label: string;
  onClick: () => void;
};

export const MinusIconButton: FC<Props> = ({ label, onClick }) => (
  <HStack gap="5px">
    <IconButton onClick={onClick} aria-label={label} icon={<MinusIcon />} />
    <Text>{label}</Text>
  </HStack>
);
